"use strict";
/**
 * 合并对象（浅拷贝）
 *
 * ### Example
 * ```
 * objectAssign({}, { a: 1, b: 1 }, { b: 2, c: 3 }); // { a: 1, b: 2, c: 3 }
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
exports.objectAssign = tslib_1.__assign;
